import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const ProjectProcessSection = () => {
  const { language } = useLanguage();
  
  const processSteps = [
    {
      number: '01',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
          <path d="M20.71,4.63L19.37,3.29C19,2.9 18.35,2.9 17.96,3.29L9,12.25L11.75,15L20.71,6.04C21.1,5.65 21.1,5 20.71,4.63M7,14A3,3 0 0,0 4,17C4,18.31 2.84,19 2,19C2.92,20.22 4.5,21 6,21C8.41,21 10,19.1 10,17C10,15.83 9.41,14.83 8.5,14.25L7,14Z" />
        </svg>
      ),
      title: {
        fr: 'Consultation et Évaluation',
        ar: 'الاستشارة والتقييم',
        en: 'Consultation and Evaluation'
      },
      description: {
        fr: 'Nous commençons par comprendre vos besoins spécifiques en matière d\'instrumentation et nous effectuons une évaluation complète de votre site.',
        ar: 'نبدأ بفهم احتياجاتك المحددة في مجال القياس وإجراء تقييم شامل لموقعك.',
        en: 'We begin by understanding your specific instrumentation needs and conduct a comprehensive evaluation of your site.'
      }
    },
    {
      number: '02',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
          <path d="M14,2L20,8V20A2,2 0 0,1 18,22H6A2,2 0 0,1 4,20V4A2,2 0 0,1 6,2H14M18,20V9H13V4H6V20H18M12,12L16,16H13.5V19H10.5V16H8L12,12Z" />
        </svg>
      ),
      title: {
        fr: 'Conception et Planification',
        ar: 'التصميم والتخطيط',
        en: 'Design and Planning'
      },
      description: {
        fr: 'Notre équipe élabore une solution sur mesure et développe un plan détaillé pour l\'implémentation, incluant les spécifications techniques et le calendrier du projet.',
        ar: 'يقوم فريقنا بتطوير حل مخصص ووضع خطة مفصلة للتنفيذ، بما في ذلك المواصفات الفنية وجدول المشروع.',
        en: 'Our team develops a custom solution and creates a detailed implementation plan, including technical specifications and project timeline.'
      }
    },
    {
      number: '03',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
          <path d="M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L5,8.09V15.91L12,19.85L19,15.91V8.09L12,4.15M12,6.23L16.9,9.06L12,11.89L7.1,9.06L12,6.23M17,14.89L13,17.2V13.62L17,11.31V14.89M11,17.2L7,14.89V11.31L11,13.62V17.2Z" />
        </svg>
      ),
      title: {
        fr: 'Approvisionnement et Préparation',
        ar: 'التوريد والتحضير',
        en: 'Procurement and Preparation'
      },
      description: {
        fr: 'Nous nous procurons les instruments et équipements nécessaires auprès de nos partenaires de confiance et préparons tout le matériel pour l\'installation.',
        ar: 'نقوم بالحصول على الأدوات والمعدات اللازمة من شركائنا الموثوق بهم وإعداد جميع المواد للتركيب.',
        en: 'We procure the necessary instruments and equipment from our trusted partners and prepare all material for installation.'
      }
    },
    {
      number: '04',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
          <path d="M12,1L3,5V11C3,16.55 6.84,21.74 12,23C17.16,21.74 21,16.55 21,11V5L12,1M17,15.59L15.59,17L12,13.41L8.41,17L7,15.59L10.59,12L7,8.41L8.41,7L12,10.59L15.59,7L17,8.41L13.41,12L17,15.59Z" />
        </svg>
      ),
      title: {
        fr: 'Installation et Configuration',
        ar: 'التركيب والتكوين',
        en: 'Installation and Configuration'
      },
      description: {
        fr: 'Nos techniciens qualifiés effectuent l\'installation et la configuration des instruments selon les normes les plus strictes de l\'industrie.',
        ar: 'يقوم الفنيون المؤهلون لدينا بتركيب وتكوين الأجهزة وفقًا لأعلى معايير الصناعة.',
        en: 'Our qualified technicians perform installation and configuration of instruments according to the strictest industry standards.'
      }
    },
    {
      number: '05',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
          <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
        </svg>
      ),
      title: {
        fr: 'Tests et Calibration',
        ar: 'الاختبارات والمعايرة',
        en: 'Testing and Calibration'
      },
      description: {
        fr: 'Chaque instrument est rigoureusement testé et calibré pour garantir des mesures précises et fiables dans votre environnement opérationnel.',
        ar: 'يتم اختبار ومعايرة كل أداة بدقة لضمان قياسات دقيقة وموثوقة في بيئة التشغيل الخاصة بك.',
        en: 'Each instrument is rigorously tested and calibrated to ensure accurate and reliable measurements in your operational environment.'
      }
    },
    {
      number: '06',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="32" height="32">
          <path d="M2.2,16.06L3.88,12L2.2,7.94L6.26,6.26L7.94,2.2L12,3.88L16.06,2.2L17.74,6.26L21.8,7.94L20.12,12L21.8,16.06L17.74,17.74L16.06,21.8L12,20.12L7.94,21.8L6.26,17.74L2.2,16.06M4.81,9L6.05,12L4.81,15L7.79,16.21L9,19.19L12,17.95L15,19.19L16.21,16.21L19.19,15L17.95,12L19.19,9L16.21,7.79L15,4.81L12,6.05L9,4.81L7.79,7.79L4.81,9M12,10.54C11.07,10.54 10.32,11.29 10.32,12.22C10.32,13.16 11.07,13.9 12,13.9C12.93,13.9 13.68,13.16 13.68,12.22C13.68,11.29 12.93,10.54 12,10.54M12,8A4,4 0 0,1 16,12A4,4 0 0,1 12,16A4,4 0 0,1 8,12A4,4 0 0,1 12,8Z" />
        </svg>
      ),
      title: {
        fr: 'Formation et Support',
        ar: 'التدريب والدعم',
        en: 'Training and Support'
      },
      description: {
        fr: 'Nous formons votre personnel à l\'utilisation et à la maintenance des nouveaux systèmes, et offrons un support continu pour assurer leur bon fonctionnement.',
        ar: 'نقوم بتدريب موظفيك على استخدام وصيانة الأنظمة الجديدة، ونقدم الدعم المستمر لضمان حسن سير عملها.',
        en: 'We train your personnel on the use and maintenance of new systems, and provide ongoing support to ensure their proper operation.'
      }
    }
  ];

  return (
    <section className="section section-dark" style={{
      padding: '5rem 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Elements */}
      <div style={{
        position: 'absolute',
        top: '5%',
        right: '5%',
        width: '200px',
        height: '200px',
        backgroundColor: 'rgba(255, 107, 0, 0.03)',
        borderRadius: '50%',
        zIndex: 0
      }}></div>
      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '5%',
        width: '150px',
        height: '150px',
        backgroundColor: 'rgba(255, 107, 0, 0.05)',
        borderRadius: '50%',
        zIndex: 0
      }}></div>

      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1.5rem',
        position: 'relative',
        zIndex: 1
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '4rem'
        }}>
          <h2 style={{
            fontSize: '2.5rem',
            fontWeight: '700',
            marginBottom: '1.5rem',
            color: 'white',
            position: 'relative',
            display: 'inline-block'
          }}>
            {language === 'fr' ? 'Notre Processus de Projet' : 
             language === 'ar' ? 'عملية المشروع لدينا' : 
             'Our Project Process'}
            <span style={{
              position: 'absolute',
              bottom: '-10px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '80px',
              height: '4px',
              backgroundColor: 'var(--assco-orange)',
              borderRadius: '2px'
            }}></span>
          </h2>
          <p style={{
            fontSize: '1.125rem',
            color: 'rgba(255, 255, 255, 0.85)',
            maxWidth: '700px',
            margin: '0 auto',
            lineHeight: '1.7'
          }}>
            {language === 'fr' 
              ? 'Nous suivons une méthodologie éprouvée pour assurer l\'excellence dans chaque projet d\'instrumentation que nous entreprenons.' 
              : language === 'ar'
              ? 'نتبع منهجية مثبتة لضمان التميز في كل مشروع قياس نقوم به.'
              : 'We follow a proven methodology to ensure excellence in every instrumentation project we undertake.'}
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '2rem',
          position: 'relative'
        }}>
          {/* Central line for desktop */}
          <div style={{
            position: 'absolute',
            top: '0',
            bottom: '0',
            left: '50%',
            width: '2px',
            backgroundColor: '#e2e8f0',
            transform: 'translateX(-50%)',
            display: 'none',
            '@media (min-width: 768px)': {
              display: 'block'
            }
          }}></div>

          {processSteps.map((step, index) => (
            <div 
              key={step.number}
              style={{
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                borderRadius: '12px',
                padding: '2rem',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                position: 'relative',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                zIndex: 2
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 10px 30px rgba(0, 0, 0, 0.25)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 20px rgba(0, 0, 0, 0.15)';
              }}
            >
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '1rem',
                marginBottom: '1.25rem'
              }}>
                <div style={{
                  backgroundColor: 'var(--assco-orange)',
                  borderRadius: '50%',
                  width: '50px',
                  height: '50px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'white',
                  flexShrink: 0
                }}>
                  {step.icon}
                </div>
                <div>
                  <div style={{
                    fontSize: '0.875rem',
                    fontWeight: '700',
                    color: 'var(--assco-orange)',
                    marginBottom: '0.25rem',
                    letterSpacing: '0.05em'
                  }}>
                    ÉTAPE {step.number}
                  </div>
                  <h3 style={{
                    fontSize: '1.25rem',
                    fontWeight: '700',
                    color: 'white',
                    margin: 0
                  }}>
                    {language === 'fr' ? step.title.fr : 
                     language === 'ar' ? step.title.ar : 
                     step.title.en}
                  </h3>
                </div>
              </div>
              <p style={{
                fontSize: '1rem',
                color: 'rgba(255, 255, 255, 0.85)',
                lineHeight: '1.7',
                margin: 0
              }}>
                {language === 'fr' ? step.description.fr : 
                 language === 'ar' ? step.description.ar : 
                 step.description.en}
              </p>
              
              {/* Step connection */}
              {index < processSteps.length - 1 && (
                <div style={{
                  position: 'absolute',
                  bottom: '-16px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '32px',
                  height: '32px',
                  backgroundColor: 'var(--assco-orange)',
                  borderRadius: '50%',
                  border: '2px solid rgba(255, 255, 255, 0.3)',
                  zIndex: 3,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="14" 
                    height="14" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                    style={{ color: '#a0aec0' }}
                  >
                    <path d="M12 5v14M19 12l-7 7-7-7"/>
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>

        <div style={{
          textAlign: 'center',
          marginTop: '4rem'
        }}>
          <p style={{
            fontSize: '1.25rem',
            fontWeight: '600',
            color: '#2d3748'
          }}>
            {language === 'fr' 
              ? 'Prêt à démarrer votre projet d\'instrumentation avec nous ?' 
              : language === 'ar'
              ? 'هل أنت مستعد لبدء مشروع القياس الخاص بك معنا؟'
              : 'Ready to start your instrumentation project with us?'}
          </p>
          <a 
            href="/contact" 
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.5rem',
              backgroundColor: 'var(--assco-orange)',
              color: 'white',
              padding: '0.75rem 2rem',
              borderRadius: '30px',
              fontWeight: '600',
              fontSize: '1rem',
              textDecoration: 'none',
              marginTop: '1rem',
              transition: 'all 0.3s ease',
              boxShadow: '0 4px 15px rgba(255, 107, 0, 0.3)'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.backgroundColor = '#e05d0c';
              e.currentTarget.style.transform = 'translateY(-3px)';
              e.currentTarget.style.boxShadow = '0 8px 20px rgba(255, 107, 0, 0.4)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 4px 15px rgba(255, 107, 0, 0.3)';
            }}
          >
            {language === 'fr' ? 'Contactez-nous' : 
             language === 'ar' ? 'اتصل بنا' : 
             'Contact us'}
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="16" 
              height="16" 
              viewBox="0 0 20 20" 
              fill="currentColor"
            >
              <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ProjectProcessSection;
